<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },

    showBackgroundHover: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    onClick(event) {
      if (this.disabled) return;
      this.$emit('click', event);
    },
  },
};
</script>
<template>
  <div
    class="tw-cursor-pointer tw-p-3 tw-rounded-full hover:tw-bg-bg-2 tw-transition-all tw-ease-in-out"
    :class="{
      'tw-opacity-40 !tw-cursor-default': disabled,
      'hover:tw-bg-purple-100': showBackgroundHover,
    }"
    @click="onClick"
  >
    <slot />
  </div>
</template>
